import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpMessageBox from "@rmp/core/components/common/RmpMessageBox.vue";
import { masks } from "@rmp/core/constants/masks";
import RmpTextField from "@rmp/core/components/fields/RmpTextField.vue";
import { prepareInnRule, requiredRule } from "@rmp/core/utils/validation";
import RmpMasterAccountAccessApplicationBaseStep
	from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { useI18n } from "vue-i18n-composable";
import { storeToRefs } from "pinia";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessSelectCounterpartyStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectCounterparty";
import { MasterAccountAccessErrorTypeEnum } from "@rmp/id/stores/masterAccountAccess/types/MasterAccountAccessErrorTypeEnum";
import { computed, watch } from "vue";
import BatchService from "@rmp/core/services/batchService";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpSelectCounterpartyStep',
  setup(__props) {

const { colors } = useColors();

const { tc } = useI18n();

const batchService = new BatchService(({ interval: 1000 }));

const useStore = useMasterAccountAccessSelectCounterpartyStepStore;
const store = useStore();

let {
	inn,
	counterparty,
	counterpartyLoading,
	errors
} = storeToRefs(store);

const {
	fetchCounterparty
} = useStore();

const validation = {
	inn: [requiredRule(), prepareInnRule()]
};

watch(inn, async (value) => {
	if(value && validation.inn.every(v => v(value) === true)) {
		batchService.push(async () => {
			await fetchCounterparty();
		});
	} else if(counterparty.value) {
		counterparty.value = null;
	}
});

const supportEmail = process.env.VUE_APP_SUPPORT_EMAIL;

const { initialized } = usePage({ useStore });

return { __sfc: true,colors, tc, batchService, useStore, store, inn, counterparty, counterpartyLoading, errors, fetchCounterparty, validation, supportEmail, initialized, RmpText, RmpMessageBox, masks, RmpTextField, RmpMasterAccountAccessApplicationBaseStep, MasterAccountAccessErrorTypeEnum }
}

})